import { useEffect, useRef, useState } from "react";
import ThreeSixty from '@mladenilic/threesixty.js';
import generateWatchProjectImage from "../../utils/generateWatchProjectImage";
import ArrowButton from "../Atoms/ArrowButton";

// TODO: improve usability with click outside
const ThreeSixtyImagesView = ({ salesWatch, setIsOpen, isOpen }: ThreeSixtyImagesViewProps) => {
  const threeSixtyRef = useRef<HTMLDivElement>(null)
  const [threeSixty, setThreeSixty] = useState<ThreeSixty | null>(null)
  const image = salesWatch.threesixtyImages?.map((image) => generateWatchProjectImage(image, salesWatch.watch.referenceNumber));

  useEffect(() => {
    if (threeSixtyRef.current) {

      let length = 400;

      if (typeof window !== 'undefined') {
        length = window.innerWidth > 768 ? 600 : 350;
      }

      const threeSixty = new ThreeSixty(threeSixtyRef.current, {
        image,
        height: length,
        width: length,
        navigation: true,
        responsive: true,
      });

      setThreeSixty(threeSixty);
    }
  }, [threeSixtyRef, salesWatch.threesixtyImages])

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (isOpen) {
        document.body.style.overflow = 'hidden';

        window.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            setIsOpen(false)
          }
        }
        )
      } else {
        document.body.style.overflow = 'initial';
      }
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('keydown', () => { })
      }
    }
  }, [isOpen])

  return (
    <div className={`${isOpen ? 'block' : 'hidden'} w-screen h-screen absolute top-0 left-0 right-0 bottom-0 z-101`}>
      <div className="bg-black opacity-70 w-full h-full"></div>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <div className="p-4 bg-white">
          <button className="font-bold text-black text-lg absolute top-2 right-2 bg-transparent" onClick={() => setIsOpen(false)}>
            X
          </button>
          {
            image && image.length > 0 && image.map((src, index) => (
              <link key={`360-image-${index}`} rel="preload" href={src} as="image" />
            ))
          }
          <div className="relative bg-contain bg-center bg-no-repeat cursor-col-resize" ref={threeSixtyRef} />
          <div className="flex justify-evenly mt-2">
            <ArrowButton className="rotate-180" isGhost={false} onClick={() => threeSixty?.prev()} />
            <ArrowButton className="" isGhost={false} onClick={() => threeSixty?.next()} />
          </div>
        </div>
      </div>
    </div>
  )
}

type ThreeSixtyImagesViewProps = {
  salesWatch: WatchProject21Api.SalesWatch,
  setIsOpen: (isOpen: boolean) => void,
  isOpen: boolean
};

export default ThreeSixtyImagesView;
